// extracted by mini-css-extract-plugin
export default {"logo":"forgotPassword_logo__QEcsB"};